<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productLabel.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productLabel.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <a-tabs 
          :default-active-key="active_tab"
          @change="onTabChange"
        >
          <a-tab-pane :key="1">
            <span slot="tab">
              <a-icon type="ordered-list" />
              {{ $t('productLabel.serial') }}
            </span>
            <SerialOnly v-if="active_tab == 1" />
          </a-tab-pane>
          <a-tab-pane :key="2">
            <span slot="tab">
             <a-icon type="barcode" />
              {{ $t('productLabel.barcode') }}
            </span>
            <BarcodeOnly v-if="active_tab == 2" />
          </a-tab-pane>
        </a-tabs>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import SerialOnly from './components/serial-only.vue'
import BarcodeOnly from './components/barcode-only.vue'
export default {
  name: 'productLabel',
  components: {
    SerialOnly,
    BarcodeOnly
  },
  data() {
    return {
      active_tab: 1
    }
  },
  methods: {
    onTabChange(key) {
      this.active_tab = key
    }
  },
}
</script>

<style scoped lang="css">
.max-height {
  max-height: 500px;
  overflow-y: scroll;
}
.min-height {
  min-height: 400px;
}
</style>